var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"text-align":"center","padding":"0 10%"}},[_c('div',[_vm._v("PT Asuransi Jiwa Sequis Life berizin dan diawasi oleh Otoritas Jasa Keuangan")])])])])
}]

export { render, staticRenderFns }